import jwtDecode from "jwt-decode";
import {getCmsToken} from "./user";

const errorNotifyApi = `${process.env.REACT_APP_ERROR_REPORT_API}`;
const enviroment = `${process.env.REACT_APP_ENVIRONMENT}`;

export const notifyError = (response) => {
    // Step 1: Create a new XMLHttpRequest object
    try {
        if (!!errorNotifyApi && enviroment == 'PROD') {
            console.log("has error report api ", enviroment)
            let user_name = '';
            if (!!getCmsToken()?.access_token) {
                user_name = jwtDecode(getCmsToken().access_token)?.user_name;
            }
            let xhr = new XMLHttpRequest();
            let url = `${response.config?.method}-${response.config?.url}`;
            let status = response.status;
            let traceId = response.data?.traceId;
            let message = response.data?.message || response.message;
            let errorMessage = response.data?.errorCodes;
            let code = response.code;
            let content = `CMS-${enviroment}-WARNING-${window.encodeURIComponent(JSON.stringify({url, traceId, message, errorMessage, status, code, user_name}))}`

            // Step 2: Configure it to send a GET request to a URL
            xhr.open('GET', `${errorNotifyApi}${content}`, true);

            // Step 4: Send the request
            xhr.send();
        }
    } catch (e) {
        console.error(e)
    }


}